import {gql} from "@irati/utils/gql"
import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"

const query = gql`
  query getShowMaximiseUsage($businessId: ID!, $duration: String, $teamId: String) {
    reportingBusinessOverview(businessId: $businessId, duration: $duration, teamId: $teamId) {
      showMaximiseUsage
    }
  }
`

export const showMaximiseUsageKey = getQueryNames(query)[0]

export default query
